import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';

import { loadAnimation } from '@views/components/LottieCreator';

import animation1 from './images/open/data.json';
import sim1 from './images/open/images/sim_card.png';
import devicepng1 from './images/open/images/xueshengzheng.png';
import animation2 from './images/open2/data.json';
import sim2 from './images/open2/images/sim_card.png';
import devicepng2 from './images/open2/images/xueshengzheng.png';
import animation3 from './images/open3/data.json';
import CommonBtn from '@views/components/CommonBtn';
import Toast from '@widgets/Toast';
import BrowserHistory from '@helpers/BrowserHistory';
import FridayService from '@services/friday';

const DeviceSetPhone = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [phoneNumber, setPhoneNumber] = useState('');
  const deviceType = parseInt(params.current.version);

  const goToNext = () => {
    FridayService.addEvent('bind_device_initial_settings_next_click');
    var reg = /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
    if(reg.test(phoneNumber)) {
      Http.post(Api.PostDevicePhoneNumber,
        { snCode: params.current.sncode, company: params.current.company, phone: phoneNumber}
      ).then(() => {
        BrowserHistory.push(`${PUBLIC_URL}/devicebindchild?sncode=${params.current.sncode}&company=${params.current.company}&version=${params.current.version}&phone=${phoneNumber}&rfid=${params.current.rfid}&secretCode=${params.current.secretCode}`);
      });
    } else {
      Toast.show({
        type: 'strip',
        title: '手机号码格式有误'
      });
    }
  }

  const onTextInput = (e: any) => {
    let value = e.target.value || '';
    if (value.length > 11) {
      value = value.substring(0, 11);
    }
    setPhoneNumber(value);
  };

  const getAnimation = (type: number) => {
    switch(type) {
      case 1: 
        return loadAnimation({
          loop: true,
          autoplay: false,
          container: document.getElementById('lottie'),
          animationData: animation1,
        },[devicepng1, sim1]);
      case 2:
        return loadAnimation({
          loop: true,
          autoplay: false,
          container: document.getElementById('lottie'),
          animationData: animation2,
        },[devicepng2, sim2]);
      case 5:
        return loadAnimation({
          loop: true,
          autoplay: false,
          container: document.getElementById('lottie'),
          animationData: animation3,
        });
      default:
        return loadAnimation({
          loop: true,
          autoplay: false,
          container: document.getElementById('lottie'),
          animationData: animation1,
        },[devicepng1, sim1]);
    }
  }

  useEffect(() => {
    const animation = getAnimation(deviceType);
    animation?.play();
  },[deviceType]);
  
  return (
    <div styleName="container">
      <NavBar
        title="设置学生证"
      />
      <div className='flex flex-center' styleName='animation-container' id='lottie'></div>
      {(deviceType === 1 || deviceType === 2) ? (
        <div className='flex flex-center'>
          <div className='flex' styleName='tip-container'>
            <span>1. 将 “SIM卡” 插入电子学生证</span>
            <span>2. 长按“3号键”开启电子学生证</span>
            <span>3. 下方输入刚插入的SIM卡手机号</span>
          </div>
        </div>
      ) : null}
      <div className='flex' styleName='phone-input'>
        <input type='number' placeholder='请输入电子学生证手机号' onChange={onTextInput} value={phoneNumber}/>
      </div>
      <CommonBtn
        btnText="下一步"
        style={{marginTop: '.32rem'}}
        disabled={phoneNumber.length < 11}
        onConfirm={ goToNext }
      />
    </div>
  )
}

export default DeviceSetPhone;
